var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarrantyTermSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#7AB934",
    width: "40px",
    height: "40px",
    viewBox: "0 0 100 100",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,20c3.79,0,6.79,4.11,10.11,5.53s8.52.63,11,3.31,1.89,7.58,3.31,11.05S80,46.21,80,50s-4.11,6.79-5.53,10.11-.63,8.52-3.31,11c-2.53,2.52-7.58,1.89-11,3.31S53.79,80,50,80s-6.79-4.11-10.11-5.53-8.52-.63-11-3.31c-2.52-2.53-1.89-7.58-3.31-11S20,53.79,20,50s4.11-6.79,5.53-10.11.63-8.52,3.31-11S36.42,27,39.89,25.53,46.21,20,50,20Zm0,9.47A20.53,20.53,0,1,0,70.53,50,20.59,20.59,0,0,0,50,29.47Zm9.52,11.44,2,1.9a1.55,1.55,0,0,1,0,1.89L48.78,58.84a2.55,2.55,0,0,1-2,.88,2.76,2.76,0,0,1-2-.88L37.9,52a1.26,1.26,0,0,1,0-1.89l2-1.9a1.37,1.37,0,0,1,2,0l4.87,5L57.52,40.91A1.37,1.37,0,0,1,59.52,40.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyTermSvgrepoCom);
export default __webpack_public_path__ + "static/media/warranty-term-svgrepo-com.b319d1dcd4cb9b9d10522e5d6ad11f51.svg";
export { ForwardRef as ReactComponent };